// extracted by mini-css-extract-plugin
export default {"audioplayer":"AudioPlayer_audioplayer__r7KW3","playbutton":"AudioPlayer_playbutton__dPLYT"};